import { Injectable } from '@angular/core';
import {HttpService} from "./http.service";
import {CreateAPIKeyResult, CreateResult} from "../models/create-result";
import { ClientKeyNameViewModel } from '../models/client-key-name-view-model';
import { ClientAccessKeyViewModel } from '../models/client-access-key-view-model';
import { PagedResponse } from '../models/paged-response';
import { SearchFilterModel } from '../models/search-filter-model';
import { ClientViewModel } from '../models/client-view-model';


@Injectable({
  providedIn: 'root'
})
export class ClientService {

  constructor(private _httpService: HttpService) {
  }

  public async GetAllClients(): Promise<ClientViewModel[]> {
    const httpResult = await this._httpService.apiGet<ClientViewModel[]>(`Client/all`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetPagedClients(filter: SearchFilterModel): Promise<PagedResponse<ClientViewModel>> {
    debugger;
    const httpResult = await this._httpService.apiPost<PagedResponse<ClientViewModel>>(`Client/paged`, filter);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return {
      response: null,
      total: 0
    };
  }

  public async GetById(id: number): Promise<ClientViewModel> {
    const httpResult = await this._httpService.apiGet<ClientViewModel>(`Client/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async Create(Client: ClientViewModel): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`Client`,Client);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return {message: "An unknown error occured", success: false};
  }

  public async Update(Client: ClientViewModel): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPut<CreateResult>(`Client/Update`, Client);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return {message: "An unknown error occured", success: false};
  }


  public async CreateAPIKey(clientKeyName: ClientKeyNameViewModel): Promise<CreateAPIKeyResult> {
    const httpResult = await this._httpService.apiPost<CreateAPIKeyResult>(`Client/CreateAPIKey`, clientKeyName);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return {signedAccessKey: "", success: false};
  }


  public async DeleteApiKey(clientAccessKey: ClientAccessKeyViewModel): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPut<CreateResult>(`Client/InvalidateApiKey`, clientAccessKey);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "Failed to delete api Key", success: false };
  }

}
